import React from 'react';
import cl from './Terms.module.css';

const Terms = (props) => {
  return (
    <section className={cl.app_policy}>
      <h1>Termini di servizio</h1>
       <h2>PANORAMICA</h2>
       <p>
         Questo sito web è gestito da {props.domain}. In tutto il sito, il
         i termini “noi”, “ci” e “nostro” si riferiscono
         {props.domain} offre questo sito Web, comprese tutte le informazioni, gli strumenti e
         servizi disponibili da questo sito a te, l'utente, condizionati
         l'accettazione di tutti i termini, condizioni, politiche e comunicazioni indicati
         Qui.
       </p>

       <p>
         Visitando il nostro sito e/o acquistando qualcosa da noi, ti impegni
         il nostro "Servizio" e accetti di essere vincolato dai seguenti termini e
         condizioni (“Termini di Servizio”, “Termini”), comprese quelle aggiuntive
         termini, condizioni e politiche a cui si fa riferimento nel presente documento e/o disponibili presso
         collegamento ipertestuale. I presenti Termini di servizio si applicano a tutti gli utenti del sito,
         inclusi, senza limitazione, utenti che sono browser, fornitori, clienti,
         commercianti e/o contributori di contenuti.
       </p>
       <p>
         Si prega di leggere attentamente i presenti Termini di servizio prima di accedere o utilizzare
         il nostro sito web. Accedendo o utilizzando qualsiasi parte del sito, accetti di esserlo
         vincolato dai presenti Termini di servizio. Se non accetti tutti i termini
         e le condizioni del presente accordo, non potrai accedere al sito web o
         utilizzare eventuali servizi. Se i presenti Termini di servizio sono considerati un'offerta,
         l'accettazione è espressamente limitata ai presenti Termini di servizio.
       </p>
       <p>
         Eventuali nuove funzionalità o strumenti aggiunti allo store corrente dovranno
         essere soggetto anche ai Termini di servizio. Puoi rivedere quelli più attuali
         versione dei Termini di servizio in qualsiasi momento su questa pagina. Ci riserviamo il
         diritto di aggiornare, modificare o sostituire qualsiasi parte dei presenti Termini di servizio da parte di
         pubblicare aggiornamenti e/o modifiche al nostro sito web. È tua responsabilità
         controllare periodicamente questa pagina per eventuali modifiche. L'uso continuato di o
         l'accesso al sito web successivo alla pubblicazione delle eventuali modifiche costituisce
         accettazione di tali cambiamenti.
       </p>
       <h2>SEZIONE 1 - TERMINI DEL NEGOZIO ONLINE</h2>
       <p>
         Accettando i presenti Termini di servizio, dichiari di essere a
         almeno la maggiore età nel tuo paese di residenza, o che tu lo sia
         la maggiore età nel tuo Paese di residenza e che ci hai fornito
         il tuo consenso a consentire a qualcuno dei tuoi minori a carico di utilizzare questo sito.
         <br />
         Non è possibile utilizzare i nostri prodotti per scopi illegali o non autorizzati né
         potresti, nell'uso del Servizio, violare qualsiasi legge nel tuo
         giurisdizione (incluse ma non limitate alle leggi sul copyright). Non devi
         trasmettere worm o virus o qualsiasi codice di natura distruttiva. UN
         la violazione o la violazione di uno qualsiasi dei Termini comporterà un immediato
         cessazione dei tuoi Servizi.
       </p>
       <h2>SEZIONE 2 - CONDIZIONI GENERALI</h2>
       <p>
         Ci riserviamo il diritto di rifiutare il servizio a chiunque per qualsiasi motivo
         tempo.
         <br />
         Comprendi che i tuoi contenuti (esclusi i dati della carta di credito
         informazioni), possono essere trasferiti in chiaro e comportare (a)
         trasmissioni su varie reti; e (b) modifiche per conformarsi e
         adattarsi ai requisiti tecnici di connessione di reti o dispositivi.
         Le informazioni sulla carta di credito vengono sempre crittografate durante il trasferimento
         reti. L'utente accetta di non riprodurre, duplicare, copiare, vendere, rivendere o
         sfruttare qualsiasi parte del Servizio, utilizzo del Servizio o accesso a
         Servizio o qualsiasi contatto sul sito Web attraverso il quale il servizio è
         forniti, senza espressa autorizzazione scritta da parte nostra.
         <br />
         I titoli utilizzati nel presente contratto sono inclusi solo per comodità
         e non limiterà o influenzerà in altro modo i presenti Termini.
       </p>
       <h2>SEZIONE 3 - ACCURATEZZA, COMPLETEZZA E TEMPESTIVITÀ DELLE INFORMAZIONI</h2>
       <p>
         Non siamo responsabili se le informazioni rese disponibili su questo sito non lo sono
         accurato, completo o attuale. Il materiale presente in questo sito è previsto
         solo informazioni generali e non devono essere considerate come valide o utilizzate come tali
         unica base per prendere decisioni senza consultare il primario, altro ancora
         fonti di informazione accurate, più complete o più tempestive. Qualunque
         fare affidamento sul materiale presente su questo sito è a proprio rischio.
         <br />
         Questo sito può contenere alcune informazioni storiche. Storico
         le informazioni, necessariamente, non sono attuali e vengono fornite per l'utente
         solo come riferimento. Ci riserviamo il diritto di modificare i contenuti di questo sito
         in qualsiasi momento, ma non abbiamo l'obbligo di aggiornare alcuna informazione sul ns
         luogo. Accetti che sia tua responsabilità monitorare le modifiche al nostro
         luogo.
       </p>
       <h2>SEZIONE 4 - MODIFICHE AL SERVIZIO E PREZZI</h2>
       <p>
         I prezzi dei nostri prodotti sono soggetti a modifiche senza preavviso.
         <br />
         Ci riserviamo il diritto in qualsiasi momento di modificare o interrompere il Servizio
         (o qualsiasi parte o contenuto dello stesso) senza preavviso in qualsiasi momento.
         <br />
         Non saremo responsabili nei tuoi confronti o nei confronti di terzi per alcuno
         modifica, variazione del prezzo, sospensione o interruzione del Servizio.
       </p>
       <h2>SEZIONE 5 - PRODOTTI O SERVIZI (se applicabile)</h2>
       <p>
         Alcuni prodotti o servizi potrebbero essere disponibili esclusivamente online tramite
         il sitoweb. Questi prodotti o servizi possono avere quantità limitate e
         sono soggetti a restituzione o cambio solo in base alla nostra Politica di restituzione.
         <br />
         Abbiamo fatto ogni sforzo per visualizzare nel modo più accurato possibile i file
         colori e immagini dei nostri prodotti che appaiono nel negozio. Non possiamo
         garantire che la visualizzazione del monitor del computer sarà di qualsiasi colore
         accurato.
         <br />
         Ci riserviamo il diritto, ma non siamo obbligati, a limitare le vendite dei nostri
         prodotti o servizi a qualsiasi persona, regione geografica o giurisdizione.
         Possiamo esercitare questo diritto caso per caso. Ci riserviamo il diritto
         per limitare le quantità di qualsiasi prodotto o servizio che offriamo. Tutto
         le descrizioni dei prodotti o i prezzi dei prodotti sono soggetti a modifiche a
         in qualsiasi momento senza preavviso, a nostra esclusiva discrezione. Ci riserviamo il
         diritto di interrompere qualsiasi prodotto in qualsiasi momento. Qualsiasi offerta per qualsiasi prodotto
         o il servizio reso su questo sito è nullo laddove proibito.
         <br />
         Non garantiamo che la qualità di prodotti, servizi,
         informazioni o altro materiale acquistato o ottenuto dall'utente incontrerà
         le tue aspettative o che eventuali errori nel Servizio verranno corretti.
       </p>
       <h2>SEZIONE 6 - ACCURATEZZA DELLE INFORMAZIONI DI FATTURAZIONE E ACCOUNT</h2>
       <p>
         Ci riserviamo il diritto di rifiutare qualsiasi ordine effettuato con noi. Potremmo, in
         a nostra esclusiva discrezione, limitare o annullare le quantità acquistate per persona,
         per nucleo familiare o per ordine. Queste restrizioni possono includere ordini effettuati
         da o con lo stesso conto cliente, la stessa carta di credito e/o
         ordini che utilizzano lo stesso indirizzo di fatturazione e/o spedizione. In caso
         che apportiamo una modifica o annulliamo un ordine, potremmo tentare di notificarlo
         contattandoti l'e-mail e/o l'indirizzo/numero di telefono di fatturazione
         forniti al momento dell'ordine. Ci riserviamo il diritto di limitare
         o vietare ordini che, a nostro insindacabile giudizio, sembrano essere stati effettuati da
         concessionari, rivenditori o distributori.
       </p>
       <p>
         L'utente accetta di fornire un acquisto e un account aggiornati, completi e accurati
         informazioni per tutti gli acquisti effettuati presso il nostro punto vendita. Accetti di farlo tempestivamente
         aggiornare il tuo account e altre informazioni, incluso il tuo indirizzo email
         e numeri di carta di credito e date di scadenza, in modo da poterli completare
         le tue transazioni e contattarti secondo necessità.
       </p>
       <p>Per maggiori dettagli, consulta la nostra Politica di restituzione.</p>
       <h2>SEZIONE 7 - STRUMENTI OPZIONALI</h2>
       <p>
         Potremmo fornirti l'accesso a strumenti di terze parti su cui noi
         né monitorare né avere alcun controllo o input.
         <br />
         Riconosci e accetti che forniamo l'accesso a tali strumenti "così come sono"
         e "come disponibile" senza alcuna garanzia, dichiarazione o condizione
         di alcun tipo e senza alcuna approvazione. Non avremo alcuna responsabilità
         qualsiasi cosa derivante da o relativa all'utilizzo di terze parti facoltative
         utensili.
         <br />
         Qualsiasi utilizzo da parte tua degli strumenti opzionali offerti attraverso il sito è interamente a
         a tuo rischio e discrezione e dovresti assicurarti di avere familiarità
         e approvare i termini in base ai quali gli strumenti sono forniti da
         fornitore/i di terze parti pertinente/i.
         <br />
         Potremmo anche, in futuro, offrire nuovi servizi e/o funzionalità tramite
         il sito web (incluso il rilascio di nuovi strumenti e risorse). Come
         anche le nuove funzionalità e/o servizi saranno soggetti ai presenti Termini di
         Servizio.
       </p>
       <h2>SEZIONE 8 - LINK DI TERZE PARTI</h2>
       <p>
         Alcuni contenuti, prodotti e servizi disponibili tramite il nostro Servizio potrebbero
         includere materiali di terze parti.
         <br />
         I collegamenti di terze parti presenti su questo sito potrebbero indirizzarti a siti Web di terze parti
         che non sono affiliati con noi. Non siamo responsabili per l'esame o
         valutando il contenuto o l'accuratezza e non garantiamo e non lo faremo
         non hanno alcuna responsabilità per materiali di terze parti o
         siti Web o per qualsiasi altro materiale, prodotto o servizio di
         terzi.
         <br />
         Non siamo responsabili per eventuali danni o danni legati all'acquisto o all'utilizzo
         di beni, servizi, risorse, contenuti o qualsiasi altra transazione effettuata
         in connessione con eventuali siti Web di terzi. Si prega di rivedere attentamente il
         politiche e pratiche di terze parti e assicurati di comprenderle
         prima di intraprendere qualsiasi transazione. Reclami, reclami, preoccupazioni o
         le domande riguardanti i prodotti di terze parti devono essere indirizzate a
         terzo.
       </p>
       <h2>SEZIONE 9 - COMMENTI DEGLI UTENTI, FEEDBACK E ALTRI CONTRIBUTI</h2>
       <p>
         Se, su nostra richiesta, invii determinati contributi specifici (ad esempio
         iscrizioni al concorso) o senza una nostra richiesta invii idee creative,
         suggerimenti, proposte, piani o altri materiali, sia online, di
         e-mail, tramite posta ordinaria o in altro modo (collettivamente, "commenti") all'utente
         accetti che possiamo, in qualsiasi momento, senza restrizioni, modificare, copiare,
         pubblicare, distribuire, tradurre e utilizzare in altro modo con qualsiasi mezzo
         commenti che ci inoltri. Non abbiamo e non avremo alcun obbligo
         (1) mantenere riservati eventuali commenti; (2) pagare un risarcimento
         eventuali commenti; o (3) per rispondere a eventuali commenti.
         <br />
         Potremmo, ma non abbiamo l'obbligo di, monitorare, modificare o rimuovere i contenuti che
         determiniamo a nostra esclusiva discrezione sono illegali, offensivi,
         minaccioso, calunnioso, diffamatorio, pornografico, osceno o altro
         discutibili o violano la proprietà intellettuale di qualsiasi parte o questi
         Termini di servizio.
         <br />
         Accetti che i tuoi commenti non violeranno alcun diritto di alcuno
         di terze parti, inclusi copyright, marchi, privacy, personalità o
         altro diritto personale o di proprietà. Accetti inoltre che il tuo
         i commenti non conterranno contenuti diffamatori o comunque illeciti, abusivi o
         materiale osceno o contenere virus informatici o altri malware che
         potrebbe in alcun modo influenzare il funzionamento del Servizio o qualsiasi correlato
         sito web. Non puoi utilizzare un indirizzo e-mail falso o fingere di essere qualcuno
         diversi da te, o altrimenti fuorviare noi o terzi in merito a
         origine di eventuali commenti. Sei l'unico responsabile per qualsiasi tuo commento
         marca e la loro accuratezza. Non ci assumiamo alcuna responsabilità e assumiamo no
         responsabilità per eventuali commenti pubblicati da te o da terze parti.
       </p>
       <h2>SEZIONE 10 - INFORMAZIONI PERSONALI</h2>
       <p>
         L'invio di informazioni personali tramite il negozio è regolato da
         la nostra Informativa sulla privacy.
       </p>
       <h2>SEZIONE 11 - ERRORI, IMPRECISIONI E OMISSIONI</h2>
       <p>
         Occasionalmente potrebbero esserci informazioni sul nostro sito o nel Servizio che
         contiene errori tipografici, inesattezze o omissioni che potrebbero riguardare
         alle descrizioni dei prodotti, ai prezzi, alle promozioni, alle offerte, alla spedizione dei prodotti
         costi, tempi di transito e disponibilità. Ci riserviamo il diritto di correggere
         eventuali errori, imprecisioni o omissioni e di modificarli o aggiornarli
         informazioni o annullare ordini se qualsiasi informazione nel Servizio o su qualsiasi
         il sito Web correlato è impreciso in qualsiasi momento senza preavviso
         (anche dopo aver inviato l'ordine).
         <br />
         Non ci assumiamo alcun obbligo di aggiornare, modificare o chiarire le informazioni in
         il Servizio o su qualsiasi sito Web correlato, inclusi, a titolo esemplificativo,
         informazioni sui prezzi, salvo quanto richiesto dalla legge. Nessun aggiornamento specificato o
         dovrebbe essere la data di aggiornamento applicata nel Servizio o su qualsiasi sito Web correlato
         preso per indicare che tutte le informazioni presenti nel Servizio o su qualsiasi elemento correlato
         il sito web è stato modificato o aggiornato.
       </p>
       <h2>SEZIONE 12 - USI PROIBITI</h2>
       <p>
         Oltre ad altri divieti stabiliti nei Termini di servizio,
         è vietato utilizzare il sito o il suo contenuto: (a) per qualsiasi
         scopo illecito; (b) per sollecitare altri a esibirsi o partecipare a qualsiasi
         atti illeciti; (c) violare qualsiasi normativa internazionale o britannica,
         norme, leggi o ordinanze locali; (d) violare o violare i nostri
         diritti di proprietà intellettuale o i diritti di proprietà intellettuale di
         altri; (e) molestare, abusare, insultare, danneggiare, diffamare, calunniare, denigrare,
         intimidire o discriminare in base al genere, all'orientamento sessuale,
         religione, etnia, razza, età, origine nazionale o disabilità; (f) a
         fornire informazioni false o fuorvianti; (g) caricare o trasmettere
         virus o qualsiasi altro tipo di codice dannoso che verrà o potrebbe essere utilizzato in
         in alcun modo che possa influenzare la funzionalità o il funzionamento del Servizio
         o di qualsiasi sito Web correlato, altri siti Web o Internet; (h) a
         raccogliere o tenere traccia delle informazioni personali di altri; (i) spam, phishing,
         farmaceutico, pretesto, ragno, gattonare o raschiare; (j) per qualsiasi cosa oscena o immorale
         scopo; o (k) interferire o eludere le funzionalità di sicurezza di
         il Servizio o qualsiasi sito Web correlato, altri siti Web o Internet. Noi
         si riserva il diritto di interrompere l'utilizzo del Servizio o qualsiasi correlato
         sito web per aver violato uno qualsiasi degli usi vietati.
       </p>
       <h2>SEZIONE 13 - ESCLUSIONE DI GARANZIE; LIMITAZIONE DI RESPONSABILITÀ</h2>
       <p>
         Non garantiamo, dichiariamo o garantiamo che l'utilizzo del nostro servizio
         sarà ininterrotto, tempestivo, sicuro o privo di errori. Non garantiamo
         che i risultati che possono essere ottenuti dall'uso del servizio saranno
         essere accurato o affidabile.
         <br />
         Accetti che di tanto in tanto potremmo rimuovere il servizio per
         periodi di tempo indeterminati o annullare il servizio in qualsiasi momento, senza
         avviso a te.
         <br />
         L'utente accetta espressamente che l'utilizzo o l'impossibilità di utilizzare il servizio
         è a tuo esclusivo rischio. Il servizio e tutti i prodotti e servizi
         forniti tramite il servizio sono (salvo quanto espressamente indicato da
         noi) forniti "così come sono" e "come disponibili" per l'uso, senza alcuno
         rappresentazioni, garanzie o condizioni di qualsiasi tipo, espresse o
         implicita, comprese tutte le garanzie o condizioni implicite di
         commerciabilità, qualità commerciabile, idoneità per uno scopo particolare,
         durabilità, titolo e non violazione.
         <br />
         In nessun caso noi, i nostri direttori, funzionari, dipendenti, affiliati,
         agenti, appaltatori, stagisti, fornitori, prestatori di servizi o licenziatari
         essere responsabile per qualsiasi lesione, perdita, reclamo o qualsiasi danno diretto, indiretto,
         danni incidentali, punitivi, speciali o consequenziali di qualsiasi tipo,
         inclusi, senza limitazione, mancati profitti, mancati ricavi, mancati risparmi,
         perdita di dati, costi di sostituzione o danni simili, siano essi basati
         in contratto, torto (inclusa negligenza), responsabilità oggettiva o altro,
         derivanti dall'utilizzo di qualsiasi servizio o di qualsiasi prodotto procurato
         utilizzo del servizio, o per qualsiasi altro reclamo legato in qualsiasi modo al tuo utilizzo
         del servizio o di qualsiasi prodotto, inclusi, ma non limitati a, eventuali errori
         o omissioni in qualsiasi contenuto, o qualsiasi perdita o danno di qualsiasi tipo subiti
         come risultato dell'utilizzo del servizio o di qualsiasi contenuto (o prodotto)
         pubblicati, trasmessi o altrimenti resi disponibili tramite il servizio
         se informati della loro possibilità. Perché alcuni stati o giurisdizioni lo fanno
         non consentire l'esclusione o la limitazione di responsabilità per consequenziali
         o danni accidentali, in tali stati o giurisdizioni, la nostra responsabilità
         sarà limitato nella misura massima consentita dalla legge.
       </p>
       <h2>SEZIONE 14 - INDENNIZZO</h2>
       <p>
         Accetti di indennizzare, difendere e tenere indenni noi e i nostri genitori,
         controllate, affiliate, partner, funzionari, direttori, agenti,
         appaltatori, licenziatari, fornitori di servizi, subappaltatori, fornitori,
         stagisti e dipendenti, indenni da qualsiasi pretesa o pretesa, ivi compresa
         spese legali ragionevoli, sostenute da terze parti a causa o derivanti
         dalla violazione dei presenti Termini di servizio o dei documenti in essi contenuti
         incorporare per riferimento, o la violazione di qualsiasi legge o dei diritti di
         una terza parte.
       </p>
       <h2>SEZIONE 15 - SEPARABILITÀ</h2>
       <p>
         Nel caso in cui venga determinata una qualsiasi disposizione dei presenti Termini di servizio
         essere illegale, nulla o inapplicabile, tale disposizione sarà comunque valida
         essere applicabile nella misura massima consentita dalla legge applicabile, e
         la parte inapplicabile sarà considerata separata dalle presenti Condizioni
         del Servizio, tale determinazione non pregiudica la validità e
         efficacia di ogni altra restante disposizione.
       </p>
       <h2>SEZIONE 16 - RISOLUZIONE</h2>
       <p>
         Gli obblighi e le responsabilità delle parti assunti prima della
         la data di risoluzione sopravvivrà alla risoluzione del presente accordo per tutti
         scopi.
         <br />
         I presenti Termini di servizio sono efficaci a meno che e fino alla risoluzione da parte di
         o tu o noi. Puoi risolvere i presenti Termini di servizio in qualsiasi momento
         notificandoci che non desideri più utilizzare i nostri Servizi o quando tu
         cessare di utilizzare il nostro sito.
         <br />
         Se a nostro esclusivo giudizio fallisci, o sospettiamo che tu abbia fallito, a
         rispettare qualsiasi termine o disposizione dei presenti Termini di servizio, possiamo anche
         rescindi questo accordo in qualsiasi momento senza preavviso e rimarrai
         responsabile di tutti gli importi dovuti fino alla data di risoluzione inclusa;
         e/o di conseguenza potrebbe negarti l'accesso ai nostri Servizi (o a qualsiasi parte
         della stessa).
       </p>
       <h2>SEZIONE 17 - INTERO CONTRATTO</h2>
       <p>
         L'incapacità da parte nostra di esercitare o far valere qualsiasi diritto o disposizione di questi
         I Termini di Servizio non costituiscono una rinuncia a tale diritto o
         disposizione.
         <br />
         I presenti Termini di servizio e qualsiasi politica o regola operativa pubblicata da noi
         su questo sito o rispetto al Servizio costituisce l'intero
         accordo e intesa tra te e noi e regolano il tuo utilizzo
         il Servizio, sostituendo eventuali accordi precedenti o contemporanei,
         comunicazioni e proposte, sia orali che scritte, tra te e
         noi (incluse, ma non limitate a, eventuali versioni precedenti dei Termini di
         Servizio).
         <br />
         Eventuali ambiguità nell'interpretazione dei presenti Termini di servizio verranno eliminate
         non può essere interpretato contro il redattore.
       </p>
       <h2>SEZIONE 18 - LEGGE APPLICABILE</h2>
       <p>
         I presenti Termini di servizio e gli eventuali accordi separati in base ai quali forniamo
         i tuoi Servizi saranno regolati e interpretati in conformità con il
         leggi del Regno Unito.
       </p>
       <h2>SEZIONE 19 - MODIFICHE AI TERMINI DI SERVIZIO</h2>
       <p>
         Puoi rivedere la versione più recente dei Termini di servizio in qualsiasi momento
         volta in questa pagina. Ci riserviamo il diritto, a nostra esclusiva discrezione, di
         aggiornare, modificare o sostituire qualsiasi parte dei presenti Termini di servizio mediante pubblicazione
         aggiornamenti e modifiche al nostro sito web. È tua responsabilità controllare
         periodicamente il nostro sito web per eventuali modifiche. L'uso continuato o l'accesso a
         il nostro sito Web o il Servizio in seguito alla pubblicazione di eventuali modifiche agli stessi
         I Termini di servizio costituiscono l'accettazione di tali modifiche.
       </p>
       <h2>SEZIONE 20 - INFORMAZIONI DI CONTATTO</h2>
       <p>
         Le domande sui Termini di servizio devono essere inviate a support@
         {props.domain} Tutte le voci di cui sopra sono organizzate e regolate ai sensi dell'art
         leggi del Regno Unito.
       </p>
    </section>
  );
};

export default Terms;
